<template>
  <div>
    <!-- Content Behind the Modal -->
    <div :class="{ 'pointer-events-none': opened }">
      <slot name="background-content"></slot>
    </div>
    <!-- Modal Overlay and Content -->
    <div v-if="opened" class="fixed flex justify-center items-center inset-0 z-50 bg-gray-900 bg-opacity-70 w-full h-full">
      <div class="bg-white rounded-lg m-auto relative max-h-[82%] mx-3 p-10" :class="customClasses">
        <button @click="handleClose" class="bg-white rounded-full h-10 w-10 absolute -top-14 ltr:right-0 rtl:left-0 appearance-none p-0">
          <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
          <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
        </button>
        <p v-if="title" class="text-4xl font-bold text-gray-dark mb-4">{{ title }}</p>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    title: String,
    customClasses: {
      type: String,
      default: ""
    },
    close: Function
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  created() {
  },
  computed: {
  },
  methods: {
    handleClose(event) {
      this.$emit("close", event)
    }
  },
  watch: {
  }
}
</script>

<style scoped></style>
